export const CLASSES = [
    "Sorcerer",
    "Wizard",
    "Artificer",
    "Bard",
    "Warlock",
    "Druid",
    "Cleric",
    "Ranger",
    "Paladin",
    // "Monk"
];